module.exports = __webpack_public_path__ + "img/Personal-Growth@3x.6c0de316.png";